import e from"react";import t from"../../../external/classnames/index.js";const a=({count:a,className:r=""})=>{const s=t("badge",r,{badge__full:a>=99}),n=a>99?"+99":a.toString();return e.createElement("p",{className:s},n)};export{a as Badge};
//# sourceMappingURL=Badge.js.map
